import { render, staticRenderFns } from "./NotificationAlertSchedule.vue?vue&type=template&id=2c22d4d4&scoped=true&"
import script from "./NotificationAlertSchedule.vue?vue&type=script&lang=js&"
export * from "./NotificationAlertSchedule.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlertSchedule.vue?vue&type=style&index=0&id=2c22d4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22d4d4",
  null
  
)

export default component.exports